<template>
    <section class="sectionBackGround">
        <div class="container pt-lg-md">
            <div class="row justify-content-center" style="margin-top: 10%;">
                <div class="col-lg-5">
                    <div shadow header-classes="pb-5" body-classes="px-lg-5 py-lg-5" class="border-0">
                        <template>
                            <div class="text-center" style="
                                    color: white;
                                    font-family: ‘Noto Sans S Chinese’;
                                    font-size: 40px;
                                    font-style: normal;
                                    font-weight: 800;
                                    line-height: 58px;
                                    letter-spacing: 1px;">
                                AnthroMindXX
                            </div>
                            <div class="text-center mb-4" style="
                                    color: white;
                                    font-family: ‘Noto Sans S Chinese’;">
                                这里是一个关于健康饮食的个人网站<br />
                                用户付费后登录使用<br />
                                更多信息可以在 AntroMindXX 微博主页了解
                            </div>
                        </template>
                        <template>

                            <form role="form" @submit.prevent="handleLogin">
                                <base-input alternative class="mb-3" placeholder="用户名（至少5个字）"
                                    addon-left-icon="ni ni-email-83" v-model="username" style="
                                border-radius: 6px;
                                background: rgba(255, 255, 255, 0.40);">
                                </base-input>
                                <base-input alternative type="password" placeholder="密码"
                                    addon-left-icon="ni ni-lock-circle-open" v-model="password" style="
                                border-radius: 6px;
                                background: rgba(255, 255, 255, 0.40);">
                                </base-input>

                                <base-button style="border-radius: 8px; background: rgba(15, 245, 200, 0.90);" href="#"
                                    type="success" size="lg" block @click="handleLogin">
                                    登录
                                </base-button>

                                <div class="row mt-3">
                                    <div class="col-6 text-light">
                                        <base-checkbox>
                                            记住密码
                                        </base-checkbox>
                                    </div>
                                    <div class="col-6 text-right">
                                        <a href="#" class="text-light">
                                            <small>忘记密码?</small>
                                        </a>
                                    </div>
                                </div>

                                <base-button style="margin-top:10px; color: rgba(15, 205, 165, 0.60);
                            border-radius: 8px;
                            border: 0.8px solid rgba(15, 245, 200, 0.40);
                            " tag="a" href="#/register" outline block size="lg" type="primary">没有账户？去注册
                                </base-button>


                            </form>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            username: '',
            password: '',
        };
    },
    created() {
        // 页面加载时检查 token
        const token = this.getCookie('token');

        if (token) {
            this.verifyToken(token);
        } else {
            // 如果没有 token，跳转到登录页面
            this.$router.push('/login');  // 返回到登录页面
        }
    },
    methods: {
        // 获取 cookie
        getCookie(name) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) return parts.pop().split(';').shift();
        },
        // 验证 token
        async verifyToken(token) {
            try {
                // 使用 URL 编码格式发送数据
                const params = new URLSearchParams();
                params.append('token', token);

                const response = await axios.post('https://anthromindxx.com/ca.php?action=verifyToken', params, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                });



                if (response.data.success) {
                    const { status, timeover } = response.data;
                    const parsedStatus = parseInt(status, 10);
                    const parsedTimeover = parseInt(timeover, 10);

                    if (parsedTimeover === 1 && (parsedStatus === 1 || parsedStatus === 2 || parsedStatus === 3)) {
                        this.$router.push('/DocQuery');
                    } else {
                        this.$router.push('/AboutUs');
                    }
                } else {
                   // console.error('Token verification failed:', response.data.message || 'Token validation failed');
                    this.$router.push('/login');
                }
            } catch (error) {
               // console.error('Token verification request failed:', error);
                this.$router.push('/login');
            }
        },
        // 登录处理
        async handleLogin() {
            try {
                const formData = new FormData();
                formData.append('username', this.username);
                formData.append('password', this.password);

                // 使用 FormData 发送请求
                const response = await axios.post('https://anthromindxx.com/ca.php?action=login', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });

                if (response.data.success) {
                    const { token, status, timeover } = response.data;
                    document.cookie = `token=${token};path=/`;
                    document.cookie = `username=${this.username}; path=/;`;

                    // 将 status 转换为整数再进行比较
                    const parsedStatus = parseInt(status, 10);
                    const parsedTimeover = parseInt(timeover, 10);

                    // 根据 timeover 和 parsedStatus 进行判断
                    if (timeover === 1 && (parsedStatus === 1 || parsedStatus === 3)) {
                        this.$router.push('/DocQuery');
                        window.location.reload();

                    } else {
                        this.$router.push('/AboutUs');
                        window.location.reload();

                    }
                } else {
                    alert(response.data.message || '登录失败');
                }
            } catch (error) {
                console.error('Login failed', error);
            }
        }
    },
};
</script>

<style scoped>
.sectionBackGround {
    /* 使内容区域填充剩余空间 */
    min-height: calc(100vh - 48px);
    /* 确保内容区域至少与视口高度减去头部高度一样大 */
    background-image: url('https://anthromindxx.com/ant/login.png');
    /* 设置背景图路径 */
    background-position: center center;
    /* 背景图片位置 */
    background-attachment: fixed;
    /* 背景图片相对于视口固定 */
    background-size: 100% 100%;
    /* 背景图片根据元素大小缩放 */
    overflow-y: auto;
    /* 在内容较多时显示滚动条 */
}
</style>